import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVideo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_4315_185722",
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: "100%",
			height: "100%",
			children: /* @__PURE__ */ _jsx("rect", {
				width: "100%",
				height: "100%",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_4315_185722)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M2.46968 10.2033C2.14373 10.2205 1.81778 10.1695 1.51266 10.0535C1.20754 9.93758 0.929979 9.75924 0.697714 9.52991C0.465449 9.30059 0.283594 9.02531 0.163777 8.7217C0.0439609 8.41808 -0.0111807 8.0928 0.00187856 7.76666V3.63986C-0.0111807 3.31372 0.0439609 2.98844 0.163777 2.68482C0.283594 2.38121 0.465449 2.10593 0.697714 1.87661C0.929979 1.64728 1.20754 1.46894 1.51266 1.35299C1.81778 1.23705 2.14373 1.18605 2.46968 1.20326H5.94488C6.27083 1.18605 6.59678 1.23705 6.9019 1.35299C7.20701 1.46894 7.48458 1.64728 7.71684 1.87661C7.94911 2.10593 8.13096 2.38121 8.25078 2.68482C8.3706 2.98844 8.42574 3.31372 8.41268 3.63986V7.76726C8.42565 8.09335 8.37045 8.41856 8.25059 8.72211C8.13074 9.02565 7.94887 9.30085 7.71661 9.53012C7.48436 9.75938 7.20682 9.93766 6.90175 10.0536C6.59668 10.1695 6.27078 10.2205 5.94488 10.2033H2.46968ZM10.7761 8.77526L9.88808 8.32706C9.72691 8.24512 9.59171 8.11996 9.49762 7.96557C9.40352 7.81118 9.35424 7.63366 9.35528 7.45286V3.95306C9.35405 3.77238 9.40327 3.59494 9.49739 3.44071C9.59152 3.28648 9.72683 3.16158 9.88808 3.08006L10.7767 2.63066C10.9054 2.56476 11.0492 2.53363 11.1937 2.54037C11.3382 2.5471 11.4784 2.59146 11.6005 2.66906C11.724 2.74684 11.8257 2.8548 11.8959 2.98277C11.9661 3.11074 12.0026 3.25449 12.0019 3.40046V8.00606C12.0027 8.15205 11.9663 8.29585 11.8961 8.42383C11.8258 8.55182 11.7241 8.65977 11.6005 8.73746C11.467 8.82168 11.3125 8.8666 11.1547 8.86706C11.023 8.8671 10.8933 8.83584 10.7761 8.77586V8.77526Z",
				fill: "#545F7E"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgVideo);
export default ForwardRef;
